
import { CompanyReviewSummary } from "../Model/companyReviewsObjects";
import { COMPANY_REVIEW_SUMMARY } from "../Reducers/companyReviewSummaryReducer";
import { fetchCompanyReviewSummary } from "../Util/queries";

export const getCompanyReviewSummary = (companyId) => async (dispatch) => {
    try {
        const response = await fetchCompanyReviewSummary(companyId);
        dispatch({
            type: COMPANY_REVIEW_SUMMARY,
            payload: new CompanyReviewSummary(companyId, response.data)
        });

    } catch (error) {
        console.error(error);
        dispatch({
            type: COMPANY_REVIEW_SUMMARY,
            payload: new CompanyReviewSummary(companyId, {})
        });
    }
}